var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowerHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 196,
    viewBox: "0 0 261 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.0058 17.8875C49.3085 25.2158 14.7114 20.941 0 17.8875V169.797C0 188.729 14.2041 194.48 21.3061 194.988C85.9854 195.752 219.91 196.82 238.172 194.988C256.434 193.156 261 177.431 261 169.797V27.0479C239.694 20.941 189.624 7.35306 159.796 1.85683C122.51 -5.01347 95.8775 8.72712 70.0058 17.8875Z",
    fill: "#ADB3FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerHover);
export default __webpack_public_path__ + "static/media/lowerHover.4649ef3b307a4190a6290fd9458d4833.svg";
export { ForwardRef as ReactComponent };